module.exports = __webpack_public_path__ + "img/BannerMasuda_1920x650-min.08c338f0.jpg";